define('utils/tools', ['require','exports','module'],function (require, factory) {
    'use strict';

    return {
        extend: function (to, from) {
            for (var key in from) {
                to[key] = from[key]
            }
            return to
        },
        toVaildData: function (keys, src) {
            var temp = {}
            var i = 0
            var key

            while (key = keys[i++]) {
                temp[key] = src[key]
            }

            return temp
        },
        /**
         * get the value from obj property include nested object property
         * @param {Object} obj source
         * @param {String} path point chained path
         * @return {Mixed}
         */
        getValueByPath: function (obj, path) {
            return (new Function('obj', 'return obj.' + path))(obj)
        },
        /**
         * set the value from obj property include nested object property
         * @param {Object} obj source
         * @param {String} path point chained path
         * @param {Mixed} value 
         */
        setValueByPath: function (obj, path, value) {
            (new Function('obj', 'value', 'obj.' + path + '= value'))(obj, value)
        },
        resetPageData: function (vm, listKey, pageIndexKey) {
            this.setValueByPath(vm, listKey, [])
            this.setValueByPath(vm, pageIndexKey, 1)
        },
        checkForm: function (els) {
            var i = els.length
            var regex = /^\s*$/
            var el

            while (i--) {
                el = els[i]
                if (regex.test(el.value)) {
                    return false;
                }
            }

            return true;
        },
        clearForm: function (els) {
            var i = els.length
            var el
            while (i--) {
                el = els[i]
                el.value = ''
            }
        },
        polling: function (query, success, interval, timeout) {
            interval = interval || 100
            timeout = timeout || 10 * 1000

            var target = null
            var startTime = Date.now()
            var getTarget = function (selector) {
                return document.querySelector(selector)
            }

            if ((target = getTarget(query))) {
                success(target)
                return;
            }

            var timer = setInterval(function () {
                if ((target = getTarget(query))) {
                    success(target)
                    clearInterval(timer)
                    return;
                }

                if (Date.now() - startTime >= timeout) {
                    clearInterval(timer)
                    console.warn('轮询超时')
                }
            }, interval)
        }
    }
});
